"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postNotificationSchema = exports.SEVERITY_TYPES = void 0;
const zod_1 = require("zod");
exports.SEVERITY_TYPES = ['warning', 'success', 'info', 'error'];
exports.postNotificationSchema = zod_1.z.object({
    title: zod_1.z.string().optional(),
    message: zod_1.z.string(),
    severity: zod_1.z.enum(exports.SEVERITY_TYPES).optional(),
    closeable: zod_1.z.coerce.boolean().optional(),
});
